const TotalLineComponent = (props) => {
  const { listData, labelField, totalField } = props;
  const mapTotal = {};

  let totalAmount = 0;
  let totalCount = 0;
  for (let i = 0; i < listData.length; i++) {
    const label = listData[i][labelField];
    const total = listData[i][totalField];

    // mapTotal[label] = mapTotal[label] ? mapTotal[label] + total : total;

    if ( total > 0 ) {
      if (mapTotal[label] == undefined) {
        mapTotal[label] = {
          total: 0,
          count: 0,
        };
      }
      mapTotal[label].total += total;
      mapTotal[label].count += 1;

      totalAmount += total;
      totalCount += 1;
    }
  }
  mapTotal["TOTAL"] = {
    total: totalAmount,
    count: totalCount,
  };

  const listComponent = [];
  for (const key in mapTotal) {
    listComponent.push(
      <div key={key} className="row-between-center gap-3">
        <span className="font-semibold text-indigo-400">
          {key.toUpperCase()}({mapTotal[key].count.toLocaleString("id-ID")})
        </span>
        <span>{mapTotal[key].total.toLocaleString("id-ID")}</span>
      </div>
    );
  }

  return (
    <div className="row-end-center w-full pr-4 gap-10">{listComponent}</div>
  );
};

export default TotalLineComponent;
